module.exports = __webpack_public_path__ + "img/section-about.730a2422.jpeg";